import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFormImportInstanceProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IFormImportInstanceProps>>
): IComponentSchema<IFormImportInstanceProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Form Import Instance',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.FormImportInstance,
    'x-component-props': {
      text: 'Import',
      transformer: 'form.source.id',
      keepFields: ['id'],
      actionForm: { title: 'Import data', confirmText: 'Import' },
    },
    'x-component-props-config': {},
  };
};
